import { createStyles } from '@mantine/core';

export default createStyles((theme) => ({
  yearLevel: {},

  calendarHeader: {
    marginBottom: theme.spacing.xs,
  },
}));
